export default __webpack_public_path__ + "static/anchor-01a-do-019952efb438b04b38cd9203dc51e32cd7a1571a224586f4913948941508df7b.png";